export enum USER_ROLE {
  patient = 'patient',
  doctor = 'doctor',
  // Clinician types that may complete and sign medical orders, per the MOLST
  // form's own instructions (MD / NP / PA). They share the doctor flows.
  nursePractitioner = 'nurse_practitioner',
  physicianAssistant = 'physician_assistant',
  proxy = 'proxy',
  admin = 'admin',
}

/** Roles that use the clinician (doctor-side) UI and flows. */
export const CLINICIAN_ROLES: readonly USER_ROLE[] = [
  USER_ROLE.doctor,
  USER_ROLE.nursePractitioner,
  USER_ROLE.physicianAssistant,
];
